import { gql } from '@apollo/client';

export const GQL_GET_OTP = gql`
  query sendOTP($input: DetailTransfer!) {
    sendOTP(input: $input) {
      status
    }
  }
`;
